// extracted by mini-css-extract-plugin
export default {"circle__cursor":"styles_circle__cursor__Zez1T","circle__cursor__dot":"styles_circle__cursor__dot__vpPPa"};